<div class="cabinetwrapper">
    <div class="content-block"> 
        <div class="mb-3 d-flex align-items-center" (click)="goBack()">  
            <h3 class="text-heading-3 cursor-pointer"><img src="../../../../assets/images/storelist/backarrow.svg"> Devices at {{ isStore ? storeDetails.name : '--' }}</h3>
        </div>
    </div> 
    <div>
      <ul class="nav nav-pills mb-3" id="homepills" role="tablist">
        <li class="nav-item" role="presentation">
          <button class="nav-link" [class.active]="activeTab === 'cabinets'" (click)="setActiveTab('cabinets')" type="button" role="tab" aria-controls="pills-home" aria-selected="false">
            <div class="d-flex headerName text-heading-6"><img class="deviceimg-content" src="../../../../assets/images/storelist/cabinets.svg" alt="alerts">Cabinet </div>
          </button>
        </li>
        <!-- <li class="nav-item" role="presentation">
          <button class="nav-link" [class.active]="activeTab === 'desktop'" (click)="setActiveTab('desktop')" type="button" role="tab" aria-controls="pills-profile" aria-selected="false">
            <div class="d-flex headerName text-heading-6"><img class="deviceimg-content" src="../../../assets/images/storelist/desktop.svg" alt="alerts">Desktop</div>
          </button>
        </li> -->
        <li class="nav-item" role="presentation">
          <button class="nav-link" [class.active]="activeTab === 'handheld'" (click)="setActiveTab('handheld')"  type="button" role="tab" aria-controls="pills-contact" aria-selected="false">
            <div class="d-flex headerName text-heading-6"><img class="deviceimg-content" src="../../../assets/images/storelist/handheld.svg" alt="alerts">Handheld</div>
          </button>
        </li> 
      </ul> 
      <div class="tab-content" id="pills-tabContent">
        <div class="tab-pane fade show active" [class.show]="activeTab === 'cabinets'" [class.active]="activeTab === 'cabinets'" id="pills-home" role="tabpanel" aria-labelledby="pills-home-tab">
            <div class="cabinetwrapper"> 
                <div class="content-block"> 
                    <div *ngIf="isCabinets" class="table-container">
                        <div class="table-top-wrapper">
                            <div class="flex-container gap-2">
                                <h4 class="text-heading-4">Total Cabinets: {{ totalCabinets }}</h4>
                            </div>
                            <div class="search-controls">
                                <form class="search-block" (submit)="onSearchSubmit()">
                                    <div class="search-input">
                                        <input type="text" name="search" [(ngModel)]="searchInput" placeholder="Search by cabinet unique name">
                                    </div>
                                    <button type="submit" class="icon-btn">
                                        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M15.2513 12.9228L16.8527 14.5242C17.4953 15.1668 17.4953 16.2086 16.8527 16.8512C16.2101 17.4938 15.1683 17.4938 14.5257 16.8512L12.9243 15.2498M0.667969 7.74984C0.667969 3.83782 3.83929 0.666504 7.7513 0.666504C11.6633 0.666504 14.8346 3.83782 14.8346 7.74984C14.8346 11.6619 11.6633 14.8332 7.7513 14.8332C3.83929 14.8332 0.667969 11.6619 0.667969 7.74984Z" stroke="white" stroke-width="1.25" stroke-linecap="round"/>
                                        </svg>
                                    </button>
                                </form>
                                                <button type="button" class="reset-btn" (click)="reset($event)">
                    Reset
                </button>
                            </div>
                        </div>
                
                        <div class="table-wrapper table-responsive">
                            <table class="table">
                                <thead>
                                    <tr>
                                        <th class="" scope="col">Cabinet Unique Name(CUN)</th>
                                        <th class="" scope="col">Device ID</th>
                                        <th class="" scope="col">
                                            Stock Count
                                            <span (click)="stockCountSort()">
                                                <img class="sort-img" src="../../../assets/images/table/sort.png" alt="">
                                            </span>
                                        </th>
                                        <th class="" scope="col">
                                            Stock Missed this Week
                                            <span (click)="missedCountSort()">
                                                <img class="sort-img" src="../../../assets/images/table/sort.png" alt="">
                                            </span>
                                        </th>
                                        <th class="" scope="col">
                                            Stock Expiring in 30 days
                                            <span (click)="expiryCountSort()">
                                                <img class="sort-img" src="../../../assets/images/table/sort.png" alt="">
                                            </span>
                                        </th>
                                        <th class="" scope="col">
                                            Last synced
                                            <span (click)="updatedAtSort()">
                                                <img class="sort-img" src="../../../assets/images/table/sort.png" alt="">
                                            </span>
                                        </th>
                                        <th class="" scope="col"></th> 
                                    </tr>
                                </thead>
                                <tbody *ngIf="isFilterResult">
                                    <tr *ngFor="let cabinet of cabinets" (click)="navigateToDetailPage(cabinet.id)">
                                        <th scope="row">{{ cabinet.u_name }}</th>
                                        <td class="text-start">{{ cabinet.device_id }}</td>
                                        <td class="text-center">{{ cabinet.stock_count }}</td>
                                        <td class="text-center">{{ cabinet.missed_stock_by_week }}</td>
                                        <td class="text-center">{{ cabinet.expiry_products }}</td>
                                        <td class="text-start">{{ cabinet.last_updated_at ? timestampFormat(cabinet.last_updated_at,"DD/MM/YYYY, H:mm:ss") : '-- --' }}</td>   
                                        <td class="text-center position-relative" (click)="openPopup($event)">
                                            <span>
                                                <img src="../../../assets/images/table/three_dots.png" alt="dots">
                                            </span>
                                            <div id="dots-popup" class="dots-popup">
                                                <ul>
                                                    <li (click)="openDialog(cabinet.u_name, 'u_name', cabinet.id)">Edit Unique Name</li>
                                                    <li (click)="openDialog(cabinet.u_name, 'order_quantity', cabinet.id)">Minimum Order Quantity</li>
                                                </ul>
                                            </div>                             
                                        </td>
                                    </tr>
                                </tbody>
                                <tbody *ngIf="!isFilterResult">
                                    <td colspan="6">
                                        <div class="p-3 no-record text-center flex-container flex-column justify-content-center">
                                            <img src="../../../assets/images/table/filter_empty_screen.svg" alt="" srcset="">
                                            <h2 class="header-2 mb-2">No records were found matching your search</h2>
                                        </div>
                                    </td>
                                </tbody>
                            </table>
                        </div>
                
                        <div class="" *ngIf="totalPages > 1 && isCabinets">
                            <app-pagination [totalPages]="totalPages" (queryPage)="getQueryPage($event)"></app-pagination>
                        </div>
                    </div>
                    <div *ngIf="!isCabinets" class="p-3 no-record text-center flex-container flex-column justify-content-center">
                        <img src="../../../assets/images/cabinet/cabinet_empty.png" alt="" srcset="">
                        <h2 class="header-2 mb-2">No cabinets have been added yet.</h2>
                    </div>
                </div>
            </div>
        </div>
        <div class="tab-pane fade" [class.show]="activeTab === 'desktop'" [class.active]="activeTab === 'desktop'"  id="pills-profile" role="tabpanel" aria-labelledby="pills-profile-tab">
         <app-desktop-devices></app-desktop-devices>
        </div>
        <div class="tab-pane fade" [class.show]="activeTab === 'handheld'" [class.active]="activeTab === 'handheld'" id="pills-contact" role="tabpanel" aria-labelledby="pills-contact-tab">
            <app-handheld-devices></app-handheld-devices>
        </div>
      </div>
    </div>
  </div>
     